import React from 'react';
import { Clock, MapPin, ChurchIcon } from 'lucide-react';
const EventDetails = () => {
  const events = [{
    title: 'Ceremony',
    date: 'February 14, 2026',
    time: '10:00 AM - 12:00 PM',
    location: 'Wedding Venue',
    address: 'Lagos State, Nigeria (Venue details shared with RSVP guests)',
    mapUrl: '#rsvp',
    icon: <ChurchIcon size={28} className="text-gold" data-id="element-30" />
  }, {
    title: 'Reception',
    date: 'February 14, 2026',
    time: '1:00 PM - 8:00 PM',
    location: 'Reception Venue',
    address: 'Lagos State, Nigeria (Venue details shared with RSVP guests)',
    mapUrl: '#rsvp',
    icon: <div size={28} className="text-gold" data-id="element-31" />
  }];
  return <section id="events" className="bg-white py-20" data-id="element-32">
      <div className="section-container" data-id="element-33">
        <h2 className="section-heading" data-id="element-34">Event Details</h2>
        <div className="grid md:grid-cols-2 gap-10 max-w-5xl mx-auto" data-id="element-35">
          {events.map((event, index) => <div key={index} className="bg-ivory border border-champagne border-opacity-40 p-8 rounded-md shadow-sm hover:shadow-md transition-shadow" data-id="element-36">
              <div className="flex items-center mb-6" data-id="element-37">
                {event.icon}
                <h3 className="font-serif text-2xl ml-3 text-gray-800" data-id="element-38">
                  {event.title}
                </h3>
              </div>
              <div className="space-y-4" data-id="element-39">
                <div className="flex items-start" data-id="element-40">
                  <Clock size={20} className="text-gold mt-1 mr-3 flex-shrink-0" data-id="element-41" />
                  <div data-id="element-42">
                    <p className="font-medium text-gray-800" data-id="element-43">{event.date}</p>
                    <p className="text-gray-600" data-id="element-44">{event.time}</p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-45">
                  <MapPin size={20} className="text-gold mt-1 mr-3 flex-shrink-0" data-id="element-46" />
                  <div data-id="element-47">
                    <p className="font-medium text-gray-800" data-id="element-48">
                      {event.location}
                    </p>
                    <p className="text-gray-600" data-id="element-49">{event.address}</p>
                  </div>
                </div>
              </div>
              <a href={event.mapUrl} className="inline-block mt-6 px-5 py-2 border border-gold text-gold font-sans text-sm hover:bg-gold hover:text-white transition-colors duration-300" data-id="element-50">
                RSVP for Details
              </a>
            </div>)}
        </div>
      </div>
    </section>;
};
export default EventDetails;